import { Link } from "gatsby"
import React from "react"

export const As: React.FC<{ as: string; [x: string]: any }> = ({
  as,
  ...props
}) => {
  return React.createElement(as, props)
}
